import { useParams } from "react-router-dom";

const useGetOrgaCertificate = () => {
    const { orga_slug, certificate_slug } = useParams<IGetOrgaCertificateParams>();
    return { orga_slug, certificate_slug };
};

export default useGetOrgaCertificate;
